import React from "react";
import { Drawer as DrawerPrimitive } from "vaul";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { DrawerTriggerProps } from "../types";

function DrawerTrigger({ className, ...props }: DrawerTriggerProps) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <DrawerPrimitive.Trigger
      data-slot="drawer-trigger"
      className={cn(className, classes)}
      {...native}
    />
  );
}

DrawerTrigger.displayName = "Drawer.Trigger";

export default DrawerTrigger;
